/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-07-01 14:49:44
 *
 *******************************************************/
// @flow

// Dynamic bundle
export const PLACEMENT_BUNDLE_OPTIONS = [
  { value: 'instant-search-widget', label: 'AdminHTML.PredictiveBundle.Item.setting03_Checkbox02' },
  { value: 'search-result-page', label: 'AdminHTML.PredictiveBundle.Item.setting03_Checkbox01' }
];

export const DISCOUNT_BUNDLE_TYPES = [
  { value: 'none', label: 'AdminHTML.PredictiveBundle.Item.discountType01' },
  { value: 'percentage', label: 'AdminHTML.PredictiveBundle.Item.discountType02' },
  { value: 'amount', label: 'AdminHTML.PredictiveBundle.Item.discountType03' }
];

export const BUNDLE_STATUS_OPTIONS = [
  { value: 'active', label: 'AdminHTML.PredictiveBundle.Item.bundleStatus_Active' },
  { value: 'inactive', label: 'AdminHTML.PredictiveBundle.Item.bundleStatus_Paused' }
];

export const BUNDLE_DEFAULT_DESIGN_SETTINGS = {
  titleName: 'Buy more and save',
  templateType: 'default',
  titleAlignment: 'center',
  titleTextColor: '#7A7A7A',
  titleFont: 'Poppins',
  titleTextTransform: 'uppercase',
  titleFontStyle: 'regular',
  titleFontSize: 12,
  buttonBackgroundColor: '#111111',
  buttonText: 'Add bundle to cart',
  buttonTextColor: '#FFFFFF',
  isDefault: false
};

export const COLUMN_PREDICTIVE_BUNDLE = [
  { value: 'name', label: 'colName01', textAlign: 'left', width: 27, width2: 26 },
  { value: 'status', label: 'colName02', textAlign: 'left', width: 12, width2: 11 },
  { value: 'widgetId', label: 'colName03', textAlign: 'left', width: 27, width2: 24 },
  { value: 'placement', label: 'colName04', textAlign: 'left', width: 24, width2: 23 },
  { value: 'actions', label: 'colName05', textAlign: 'center', width: 10, width2: 16 }
];
